import { useEffect, useState } from 'react'

console.log('executeWhenAppReady:', typeof window.executeWhenAppReady)
console.log('makeInAppPurchase:', typeof window.makeInAppPurchase)
console.log('restorePurchases:', typeof window.restorePurchases)
console.log('__IN_APP__:', window.__IN_APP__)
console.log('navigator.userAgent: ' + navigator.userAgent)

function inWrapperNow() {
	if (typeof window === 'undefined') return false
	return typeof window.executeWhenAppReady === 'function'
}

function hasIapBridgeNow() {
	if (typeof window === 'undefined') return false
	return (
		typeof window.makeInAppPurchase === 'function' ||
		typeof window.restorePurchases === 'function'
	)
}

// returns: { inWrapper: boolean, hasIap: boolean }
export default function useInApp() {
	const [state, setState] = useState({
		inWrapper: inWrapperNow(),
		hasIap: hasIapBridgeNow(),
	})

	useEffect(() => {
		if (typeof window === 'undefined') return

		const refresh = () =>
			setState({
				inWrapper: inWrapperNow(),
				hasIap: hasIapBridgeNow(),
			})

		if (typeof window.executeWhenAppReady === 'function') {
			window.executeWhenAppReady(() => refresh())
		} else {
			refresh()
		}
	}, [])

	return state
}
